import React from 'react';
import ApplicationQuestionField from './ApplicationQuestionField';
import DataGridAnswerTable from './DataGridAnswerTable';
import { shouldHideQuestionInAnswerList } from './applicationQuestionRenderers';
import {
  coerceAnswerValueForQuestion,
} from '../../../utils/applicationAnswerCoercion';
import {
  isDataGridQuestionType,
  resolveQuestionForStoredAnswer,
} from '../../../utils/dataGridAnswerDisplay';

/**
 * Read-only submission answer renderer — uses the same field/table layout as apply/edit forms.
 */
export default function SubmissionAnswerValue({
  question,
  value,
  answer,
  questionById,
  answersContext = {},
  attachmentDeliveryMode = 'open',
}) {
  const q = question || resolveQuestionForStoredAnswer(answer, questionById);
  const rawVal = value ?? answer?.value;
  const val = q ? coerceAnswerValueForQuestion(q, rawVal) : rawVal;

  if (!q) return <span className="text-gray-400">—</span>;
  if (shouldHideQuestionInAnswerList(q)) return null;

  if (isDataGridQuestionType(q)) {
    return <DataGridAnswerTable question={q} value={val} />;
  }

  let ctx = answersContext;
  if (!ctx.__questionsByKey && questionById && typeof questionById.values === 'function') {
    const questionsByKey = {};
    for (const qq of questionById.values()) {
      const fk = String(qq?.fieldKey || '').trim();
      if (fk) questionsByKey[fk] = qq;
      if (qq?.id) questionsByKey[String(qq.id)] = qq;
    }
    ctx = { ...answersContext, __questionsByKey: questionsByKey };
  }

  return (
    <ApplicationQuestionField
      question={q}
      value={val}
      readOnly
      showLabel={false}
      answersContext={ctx}
      attachmentDeliveryMode={attachmentDeliveryMode}
    />
  );
}
